import { PiPackage } from "react-icons/pi";
import Moment from "react-moment";
import { NavLink } from "react-router-dom";
import { ORDER_STATUS } from "../../constants";
import { carrierIcons } from "../../assets/icons";
import { HiOutlineArrowRight, HiOutlineClock } from "react-icons/hi2";

export function OrderRow({ order }) {
  const isCancelled = order.orderStatus === ORDER_STATUS.CANCELLED;
  const logo = carrierIcons[order.carrier?.carrierName];

  return (
    <NavLink
      to={`/dashboard/orders/${order.orderId}`}
      className="group grid grid-cols-12 gap-4 items-center px-6 py-5 
                 border-b border-gray-100 
                         transition-all duration-200
        hover:border-[#0052FF]/40
        hover:bg-[#0052FF]/[0.025] z-100
        hover:border
        hover:rounded-sm
                 "
    >
      {/* Shipment Icon + Carrier */}
      <div className="col-span-4 flex items-center gap-4 space-x-2">
        {/* Package + Carrier logo */}
        <div
          className="
      relative flex-shrink-0 w-14 h-14 rounded-xl
      flex items-center justify-center
      bg-[#0052FF]/5 text-[#0052FF]
      transition-all duration-200
      group-hover:bg-[#0052FF]/10
    "
        >
          <PiPackage className="text-2xl opacity-80" />

          {logo && (
            <div className="absolute -top-2 -right-2 flex items-center justify-center">
              <div className="w-6 h-6 object-contain">{logo}</div>
            </div>
          )}
        </div>

        {/* Carrier info */}
        <div className="flex flex-col space-y-2 min-w-0">
          <div className="flex items-center gap-2 min-w-0">
            <p className="text-base font-semibold truncate">
              {order.carrier?.carrierName || "Shipment"}
            </p>

            {isCancelled && (
              <span className="px-2 py-0.5 rounded-full text-[11px] font-medium bg-red-50 text-red-600 whitespace-nowrap">
                Cancelled
              </span>
            )}
          </div>

          {/* Service badge */}
          <div className="flex flex-wrap gap-2">
            <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600 whitespace-nowrap">
              {order.carrier?.serviceName || "Standard"}
            </span>
          </div>
        </div>
      </div>

      {/* Date */}
      <div className="col-span-3 text-gray-600 text-sm font-medium flex items-center space-x-2">
        <HiOutlineClock className="w-5 h-5" />
        <Moment format="MMMM DD, YYYY">{order.orderDate}</Moment>
      </div>

      {/* Amount */}
      <div className="col-span-3 text-right text-gray-900 font-semibold text-base">
        <div className="text-right">
          <p className="text-lg font-semibold text-gray-900 leading-none">
            ${order.charge?.amount}
          </p>
          <p className="text-xs uppercase text-gray-400">
            {order.charge?.currency || "CAD"}
          </p>
        </div>
      </div>

      {/* Status */}
      <div className="col-span-2 flex justify-end">
        <div
          className="
                  flex-shrink-0 w-10 h-10 rounded-full
                  flex items-center justify-center
                  bg-gray-100 text-gray-400
                  transition-all duration-200
                  group-hover:bg-[#0052FF]/10
                  group-hover:text-[#0052FF]
                  group-hover:translate-x-0.5
                "
        >
          <HiOutlineArrowRight className="w-5 h-5" />
        </div>
      </div>
    </NavLink>
  );
}
